import { PartnershipContentBody } from '../../components/data/data/HelpCenter/Partnership';
import ArticleLayout from '../../components/HelpCenterComponents/ArticleLayout';

const ARTICLE_TITLES = [
  'Spatial Grid Partner Ecosystem',
  'Go-To-Market (GTM) Partnership Aligned to Industry Verticals',
  'Flexible Commercial Models: License Sales & Consulting Engagements',
  'Partnership Agreements Built on Global Best Practices',
  'Why Partner with Spatial Grid',
  'Partner With Us',
];

const TOC_DATA = {
  0: ['Spatial Grid Partner Ecosystem'],
  1: ['Go-To-Market (GTM) Partnership Aligned to Industry Verticals'],
  2: ['Flexible Commercial Models: License Sales & Consulting Engagements'],
  3: ['Partnership Agreements Built on Global Best Practices'],
  4: ['Why Partner with Spatial Grid'],
  5: ['Partner With Us'],
};

const PartnershipArticles = () => {
  return (
    <ArticleLayout
      articleTitles={ARTICLE_TITLES}
      tocData={TOC_DATA}
      ContentBodyComponent={PartnershipContentBody}
      sectionName="Partnership"
      searchPlaceholder="Search Partnership documentation"
      showUseCases={true}
      showTitle={false}
    />
  );
};

export default PartnershipArticles;
